// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.InvoiceForm-module_root___eTb8Z {
  width: 880px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}
.theme--light .InvoiceForm-module_root___eTb8Z {
  background-color: #ffffff;
}
.theme--dark .InvoiceForm-module_root___eTb8Z {
  background-color: #1c1c1c;
}

.InvoiceForm-module_body___zbKFf {
  display: flex;
  padding: 1.6rem 0;
}
@media (max-width: 820px) {
  .InvoiceForm-module_body___zbKFf {
    flex-direction: column;
  }
}

.theme--light .InvoiceForm-module_colTitle___YM3Jc {
  color: #212121;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1.6rem;
}
.theme--dark .InvoiceForm-module_colTitle___YM3Jc {
  color: #f0f0f0;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1.6rem;
}

.InvoiceForm-module_leftCol___BgoWO {
  min-width: 220px;
  max-width: 240px;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  user-select: none;
}
.theme--light .InvoiceForm-module_leftCol___BgoWO {
  border-right: 1px solid #dddddd;
}
.theme--dark .InvoiceForm-module_leftCol___BgoWO {
  border-right: 1px solid #2f2f2f;
}
@media (max-width: 820px) {
  .InvoiceForm-module_leftCol___BgoWO {
    border-right: none;
    max-width: none;
  }
}

.InvoiceForm-module_infoBlock___kx49Z {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.InvoiceForm-module_infoLabel___Wmq5X {
  font-size: 1.2rem;
}
.theme--light .InvoiceForm-module_infoLabel___Wmq5X {
  color: #888888;
}
.theme--dark .InvoiceForm-module_infoLabel___Wmq5X {
  color: #a3a3a3;
}

.InvoiceForm-module_infoValue___dIUdG {
  font-size: 1.4rem;
  font-weight: 500;
}
.theme--light .InvoiceForm-module_infoValue___dIUdG {
  color: #212121;
}
.theme--dark .InvoiceForm-module_infoValue___dIUdG {
  color: #f0f0f0;
}

.InvoiceForm-module_midCol___GSRWQ {
  flex: 1;
  min-width: 320px;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.InvoiceForm-module_field___RQgmF {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.InvoiceForm-module_fieldLabel___NI6UI {
  font-size: 1.4rem;
  font-weight: 500;
}
.theme--light .InvoiceForm-module_fieldLabel___NI6UI {
  color: #212121;
}
.theme--dark .InvoiceForm-module_fieldLabel___NI6UI {
  color: #f0f0f0;
}

.InvoiceForm-module_radioGroup___bZGop {
  display: flex;
  gap: 1rem;
}

.InvoiceForm-module_radioOption___TbdYn {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 1.4rem;
  padding: 7px 12px;
  border-radius: 6px;
  transition: border-color 150ms, background-color 150ms;
}
.theme--light .InvoiceForm-module_radioOption___TbdYn {
  color: #212121;
  border: 1px solid #dddddd;
  background-color: #ffffff;
}
.theme--dark .InvoiceForm-module_radioOption___TbdYn {
  color: #f0f0f0;
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
}
.InvoiceForm-module_radioOption___TbdYn input {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  margin: 0;
  border-radius: 50%;
  cursor: pointer;
  display: grid;
  place-content: center;
  transition: border-color 150ms;
}
.theme--light .InvoiceForm-module_radioOption___TbdYn input {
  border: 1.5px solid #dddddd;
  background-color: #ffffff;
}
.theme--dark .InvoiceForm-module_radioOption___TbdYn input {
  border: 1.5px solid #2f2f2f;
  background-color: #1c1c1c;
}
.InvoiceForm-module_radioOption___TbdYn input::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff8e58;
  transform: scale(0);
  transition: transform 150ms;
}
.InvoiceForm-module_radioOption___TbdYn input:checked {
  border-color: #ff8e58;
}
.InvoiceForm-module_radioOption___TbdYn input:checked::before {
  transform: scale(1);
}

.InvoiceForm-module_radioOptionActive___sk_sl {
  border-color: #ff8e58 !important;
}

.InvoiceForm-module_inputRow___HS9H7 {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.InvoiceForm-module_currencyPrefix___DxVQB {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  border-radius: 4px;
  font-size: 1.4rem;
}
.theme--light .InvoiceForm-module_currencyPrefix___DxVQB {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #888888;
}
.theme--dark .InvoiceForm-module_currencyPrefix___DxVQB {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #a3a3a3;
}

.InvoiceForm-module_input___ttn0K {
  flex: 1;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 1.4rem;
  width: 100%;
}
.theme--light .InvoiceForm-module_input___ttn0K {
  border: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InvoiceForm-module_input___ttn0K {
  border: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.InvoiceForm-module_hiddenFileInput___riA9P {
  display: none;
}

.theme--light .InvoiceForm-module_input___ttn0K.InvoiceForm-module_invalid___sKEFF {
  border-color: #fecdca;
}
.theme--dark .InvoiceForm-module_input___ttn0K.InvoiceForm-module_invalid___sKEFF {
  border-color: #fecdca;
}

.InvoiceForm-module_fieldError___ntFII {
  margin-top: 0.4rem;
  font-size: 1.2rem;
}
.theme--light .InvoiceForm-module_fieldError___ntFII {
  color: #b42318;
}
.theme--dark .InvoiceForm-module_fieldError___ntFII {
  color: #b42318;
}

.InvoiceForm-module_input___ttn0K:disabled {
  cursor: not-allowed;
}
.theme--light .InvoiceForm-module_input___ttn0K:disabled {
  background-color: #dddddd;
  color: #888888;
}
.theme--dark .InvoiceForm-module_input___ttn0K:disabled {
  background-color: #2f2f2f;
  color: #a3a3a3;
}

.InvoiceForm-module_twoCol___Mfa_H {
  display: flex;
  gap: 1.2rem;
}
.InvoiceForm-module_twoCol___Mfa_H > * {
  flex: 1;
}

.InvoiceForm-module_calcRow___LSJsO {
  display: flex;
  gap: 1.2rem;
}

.InvoiceForm-module_calcChip___emHKg {
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.theme--light .InvoiceForm-module_calcChip___emHKg {
  border: 1px solid #dddddd;
}
.theme--dark .InvoiceForm-module_calcChip___emHKg {
  border: 1px solid #2f2f2f;
}

.InvoiceForm-module_calcChipAccent___DDqbR {
  border: 1px solid #ff8e58;
}
.theme--light .InvoiceForm-module_calcChipAccent___DDqbR {
  background-color: #ffffff;
}
.theme--dark .InvoiceForm-module_calcChipAccent___DDqbR {
  background-color: #1c1c1c;
}

.InvoiceForm-module_calcLabel___H7T4b {
  font-size: 1.2rem;
}
.theme--light .InvoiceForm-module_calcLabel___H7T4b {
  color: #888888;
}
.theme--dark .InvoiceForm-module_calcLabel___H7T4b {
  color: #a3a3a3;
}

.InvoiceForm-module_calcValue___ECviE {
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--light .InvoiceForm-module_calcValue___ECviE {
  color: #212121;
}
.theme--dark .InvoiceForm-module_calcValue___ECviE {
  color: #f0f0f0;
}

.InvoiceForm-module_rightCol___GnVxl {
  min-width: 150px;
  max-width: 200px;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
}
.theme--light .InvoiceForm-module_rightCol___GnVxl {
  border-left: 1px solid #dddddd;
}
.theme--dark .InvoiceForm-module_rightCol___GnVxl {
  border-left: 1px solid #2f2f2f;
}
@media (max-width: 820px) {
  .InvoiceForm-module_rightCol___GnVxl {
    border-left: none;
    max-width: none;
  }
}

.InvoiceForm-module_seatList___mns6H {
  display: flex;
  flex-direction: column;
  max-height: 280px;
  overflow-y: auto;
}

.InvoiceForm-module_seatRow___SIC73 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px;
  font-size: 1.4rem;
  cursor: pointer;
}
.theme--light .InvoiceForm-module_seatRow___SIC73 {
  border-top: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InvoiceForm-module_seatRow___SIC73 {
  border-top: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.theme--light .InvoiceForm-module_seatRow___SIC73:last-child {
  border-bottom: 1px solid #dddddd;
}
.theme--dark .InvoiceForm-module_seatRow___SIC73:last-child {
  border-bottom: 1px solid #2f2f2f;
}

.InvoiceForm-module_emptySeats___GJKuZ {
  font-size: 1.2rem;
  padding-top: 4px;
}
.theme--light .InvoiceForm-module_emptySeats___GJKuZ {
  color: #888888;
}
.theme--dark .InvoiceForm-module_emptySeats___GJKuZ {
  color: #a3a3a3;
}

.InvoiceForm-module_buttons___LMI0P {
  display: flex;
  gap: 1.2rem;
  justify-content: flex-end;
  padding: 1.6rem 2rem;
}
.theme--light .InvoiceForm-module_buttons___LMI0P {
  border-top: 1px solid #dddddd;
}
.theme--dark .InvoiceForm-module_buttons___LMI0P {
  border-top: 1px solid #2f2f2f;
}

.InvoiceForm-module_marketplaceDropdown___YnHCa div[class*=itemsContainer] {
  max-height: 140px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/invoiceForm/InvoiceForm.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAmBD;AD+EE;EC/FA,yBAAA;AAmBF;AD4EE;EC/FA,yBAAA;AAsBF;;AAlBA;EACC,aAAA;EACA,iBAAA;AAqBD;AAnBC;EAJD;IAKE,sBAAA;EAsBA;AACF;;AD+DE;EChFA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAqBF;ADwDE;EChFA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AA2BF;;AAvBA;EAIC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAuBD;ADwCE;ECvEA,+BAAA;AAkCF;ADqCE;ECvEA,+BAAA;AAqCF;AA3BC;EAZD;IAaE,kBAAA;IACA,eAAA;EA8BA;AACF;;AA3BA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AA8BD;;AA3BA;EAIC,iBAAA;AA2BD;ADkBE;EC/CA,cAAA;AAgCF;ADeE;EC/CA,cAAA;AAmCF;;AA9BA;EAIC,iBAAA;EACA,gBAAA;AA8BD;ADOE;ECxCA,cAAA;AAoCF;ADIE;ECxCA,cAAA;AAuCF;;AAjCA;EACC,OAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAoCD;;AAjCA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAoCD;;AAjCA;EAIC,iBAAA;EACA,gBAAA;AAiCD;ADnBE;ECjBA,cAAA;AAuCF;ADtBE;ECjBA,cAAA;AA0CF;;AApCA;EACC,aAAA;EACA,SAAA;AAuCD;;AApCA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sDAAA;AAuCD;ADzCE;ECKA,cAAA;EACA,yBAAA;EACA,yBAAA;AAuCF;AD9CE;ECKA,cAAA;EACA,yBAAA;EACA,yBAAA;AA4CF;AAzCC;EACC,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AA2CF;AD/DE;ECuBC,2BAAA;EACA,yBAAA;AA2CH;ADnEE;ECuBC,2BAAA;EACA,yBAAA;AA+CH;AA5CE;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;AA8CH;AA3CE;EACC,qBAAA;AA6CH;AA1CE;EACC,mBAAA;AA4CH;;AAvCA;EACC,gCAAA;AA0CD;;AAvCA;EACC,aAAA;EACA,QAAA;EACA,oBAAA;AA0CD;;AAvCA;EAMC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAqCD;ADzGE;EC2DA,yBAAA;EACA,yBAAA;EACA,cAAA;AAiDF;AD9GE;EC2DA,yBAAA;EACA,yBAAA;EACA,cAAA;AAsDF;;AA5CA;EAMC,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AA0CD;AD3HE;ECyEA,yBAAA;EAEA,cAAA;AAoDF;AD/HE;ECyEA,yBAAA;EAEA,cAAA;AAwDF;;AA/CA;EACC,aAAA;AAkDD;;ADvIE;EC0FA,qBAAA;AAiDF;AD3IE;EC0FA,qBAAA;AAoDF;;AAhDA;EACC,kBAAA;EACA,iBAAA;AAmDD;ADnJE;ECmGA,cAAA;AAmDF;ADtJE;ECmGA,cAAA;AAsDF;;AAlDA;EAKC,mBAAA;AAiDD;AD7JE;ECyGA,yBAAA;EACA,cAAA;AAuDF;ADjKE;ECyGA,yBAAA;EACA,cAAA;AA2DF;;AAtDA;EACC,aAAA;EACA,WAAA;AAyDD;AAvDC;EACC,OAAA;AAyDF;;AArDA;EACC,aAAA;EACA,WAAA;AAwDD;;AArDA;EAIC,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAqDD;AD3LE;EC+HA,yBAAA;AA+DF;AD9LE;EC+HA,yBAAA;AAkEF;;AAxDA;EACC,yBAAA;AA2DD;ADrME;EC6IA,yBAAA;AA2DF;ADxME;EC6IA,yBAAA;AA8DF;;AA1DA;EAIC,iBAAA;AA0DD;AD/ME;ECmJA,cAAA;AA+DF;ADlNE;ECmJA,cAAA;AAkEF;;AA7DA;EAIC,iBAAA;EACA,gBAAA;AA6DD;AD1NE;EC0JA,cAAA;AAmEF;AD7NE;EC0JA,cAAA;AAsEF;;AAhEA;EAIC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAgED;ADxOE;ECkKA,8BAAA;AAyEF;AD3OE;ECkKA,8BAAA;AA4EF;AApEC;EAVD;IAWE,iBAAA;IACA,eAAA;EAuEA;AACF;;AApEA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAuED;;AApEA;EAKC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAmED;ADpQE;ECyLA,6BAAA;EACA,cAAA;AA8EF;ADxQE;ECyLA,6BAAA;EACA,cAAA;AAkFF;;AD5QE;ECsMA,gCAAA;AA0EF;ADhRE;ECsMA,gCAAA;AA6EF;;AAzEA;EAIC,iBAAA;EACA,gBAAA;AAyED;ADxRE;EC4MA,cAAA;AA+EF;AD3RE;EC4MA,cAAA;AAkFF;;AA5EA;EAIC,aAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AA4ED;ADrSE;ECoNA,6BAAA;AAoFF;ADxSE;ECoNA,6BAAA;AAuFF;;AA9EC;EACC,iBAAA;EACA,gBAAA;AAiFF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 880px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n:global(.theme--light) .root {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .root {\n  background-color: #1c1c1c;\n}\n\n.body {\n  display: flex;\n  padding: 1.6rem 0;\n}\n@media (max-width: 820px) {\n  .body {\n    flex-direction: column;\n  }\n}\n\n:global(.theme--light) .colTitle {\n  color: #212121;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 1.6rem;\n}\n:global(.theme--dark) .colTitle {\n  color: #f0f0f0;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 1.6rem;\n}\n\n.leftCol {\n  min-width: 220px;\n  max-width: 240px;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n  user-select: none;\n}\n:global(.theme--light) .leftCol {\n  border-right: 1px solid #dddddd;\n}\n:global(.theme--dark) .leftCol {\n  border-right: 1px solid #2f2f2f;\n}\n@media (max-width: 820px) {\n  .leftCol {\n    border-right: none;\n    max-width: none;\n  }\n}\n\n.infoBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.infoLabel {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .infoLabel {\n  color: #888888;\n}\n:global(.theme--dark) .infoLabel {\n  color: #a3a3a3;\n}\n\n.infoValue {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n:global(.theme--light) .infoValue {\n  color: #212121;\n}\n:global(.theme--dark) .infoValue {\n  color: #f0f0f0;\n}\n\n.midCol {\n  flex: 1;\n  min-width: 320px;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fieldLabel {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n:global(.theme--light) .fieldLabel {\n  color: #212121;\n}\n:global(.theme--dark) .fieldLabel {\n  color: #f0f0f0;\n}\n\n.radioGroup {\n  display: flex;\n  gap: 1rem;\n}\n\n.radioOption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 1.4rem;\n  padding: 7px 12px;\n  border-radius: 6px;\n  transition: border-color 150ms, background-color 150ms;\n}\n:global(.theme--light) .radioOption {\n  color: #212121;\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n}\n:global(.theme--dark) .radioOption {\n  color: #f0f0f0;\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n}\n.radioOption input {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  display: grid;\n  place-content: center;\n  transition: border-color 150ms;\n}\n:global(.theme--light) .radioOption input {\n  border: 1.5px solid #dddddd;\n  background-color: #ffffff;\n}\n:global(.theme--dark) .radioOption input {\n  border: 1.5px solid #2f2f2f;\n  background-color: #1c1c1c;\n}\n.radioOption input::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #ff8e58;\n  transform: scale(0);\n  transition: transform 150ms;\n}\n.radioOption input:checked {\n  border-color: #ff8e58;\n}\n.radioOption input:checked::before {\n  transform: scale(1);\n}\n\n.radioOptionActive {\n  border-color: #ff8e58 !important;\n}\n\n.inputRow {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.currencyPrefix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  border-radius: 4px;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .currencyPrefix {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #888888;\n}\n:global(.theme--dark) .currencyPrefix {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #a3a3a3;\n}\n\n.input {\n  flex: 1;\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 1.4rem;\n  width: 100%;\n}\n:global(.theme--light) .input {\n  border: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .input {\n  border: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.hiddenFileInput {\n  display: none;\n}\n\n:global(.theme--light) .input.invalid {\n  border-color: #fecdca;\n}\n:global(.theme--dark) .input.invalid {\n  border-color: #fecdca;\n}\n\n.fieldError {\n  margin-top: 0.4rem;\n  font-size: 1.2rem;\n}\n:global(.theme--light) .fieldError {\n  color: #b42318;\n}\n:global(.theme--dark) .fieldError {\n  color: #b42318;\n}\n\n.input:disabled {\n  cursor: not-allowed;\n}\n:global(.theme--light) .input:disabled {\n  background-color: #dddddd;\n  color: #888888;\n}\n:global(.theme--dark) .input:disabled {\n  background-color: #2f2f2f;\n  color: #a3a3a3;\n}\n\n.twoCol {\n  display: flex;\n  gap: 1.2rem;\n}\n.twoCol > * {\n  flex: 1;\n}\n\n.calcRow {\n  display: flex;\n  gap: 1.2rem;\n}\n\n.calcChip {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n:global(.theme--light) .calcChip {\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .calcChip {\n  border: 1px solid #2f2f2f;\n}\n\n.calcChipAccent {\n  border: 1px solid #ff8e58;\n}\n:global(.theme--light) .calcChipAccent {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .calcChipAccent {\n  background-color: #1c1c1c;\n}\n\n.calcLabel {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .calcLabel {\n  color: #888888;\n}\n:global(.theme--dark) .calcLabel {\n  color: #a3a3a3;\n}\n\n.calcValue {\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--light) .calcValue {\n  color: #212121;\n}\n:global(.theme--dark) .calcValue {\n  color: #f0f0f0;\n}\n\n.rightCol {\n  min-width: 150px;\n  max-width: 200px;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n}\n:global(.theme--light) .rightCol {\n  border-left: 1px solid #dddddd;\n}\n:global(.theme--dark) .rightCol {\n  border-left: 1px solid #2f2f2f;\n}\n@media (max-width: 820px) {\n  .rightCol {\n    border-left: none;\n    max-width: none;\n  }\n}\n\n.seatList {\n  display: flex;\n  flex-direction: column;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.seatRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 4px;\n  font-size: 1.4rem;\n  cursor: pointer;\n}\n:global(.theme--light) .seatRow {\n  border-top: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .seatRow {\n  border-top: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n:global(.theme--light) .seatRow:last-child {\n  border-bottom: 1px solid #dddddd;\n}\n:global(.theme--dark) .seatRow:last-child {\n  border-bottom: 1px solid #2f2f2f;\n}\n\n.emptySeats {\n  font-size: 1.2rem;\n  padding-top: 4px;\n}\n:global(.theme--light) .emptySeats {\n  color: #888888;\n}\n:global(.theme--dark) .emptySeats {\n  color: #a3a3a3;\n}\n\n.buttons {\n  display: flex;\n  gap: 1.2rem;\n  justify-content: flex-end;\n  padding: 1.6rem 2rem;\n}\n:global(.theme--light) .buttons {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .buttons {\n  border-top: 1px solid #2f2f2f;\n}\n\n.marketplaceDropdown div[class*=itemsContainer] {\n  max-height: 140px;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InvoiceForm-module_root___eTb8Z`,
	"body": `InvoiceForm-module_body___zbKFf`,
	"colTitle": `InvoiceForm-module_colTitle___YM3Jc`,
	"leftCol": `InvoiceForm-module_leftCol___BgoWO`,
	"infoBlock": `InvoiceForm-module_infoBlock___kx49Z`,
	"infoLabel": `InvoiceForm-module_infoLabel___Wmq5X`,
	"infoValue": `InvoiceForm-module_infoValue___dIUdG`,
	"midCol": `InvoiceForm-module_midCol___GSRWQ`,
	"field": `InvoiceForm-module_field___RQgmF`,
	"fieldLabel": `InvoiceForm-module_fieldLabel___NI6UI`,
	"radioGroup": `InvoiceForm-module_radioGroup___bZGop`,
	"radioOption": `InvoiceForm-module_radioOption___TbdYn`,
	"radioOptionActive": `InvoiceForm-module_radioOptionActive___sk_sl`,
	"inputRow": `InvoiceForm-module_inputRow___HS9H7`,
	"currencyPrefix": `InvoiceForm-module_currencyPrefix___DxVQB`,
	"input": `InvoiceForm-module_input___ttn0K`,
	"hiddenFileInput": `InvoiceForm-module_hiddenFileInput___riA9P`,
	"invalid": `InvoiceForm-module_invalid___sKEFF`,
	"fieldError": `InvoiceForm-module_fieldError___ntFII`,
	"twoCol": `InvoiceForm-module_twoCol___Mfa_H`,
	"calcRow": `InvoiceForm-module_calcRow___LSJsO`,
	"calcChip": `InvoiceForm-module_calcChip___emHKg`,
	"calcChipAccent": `InvoiceForm-module_calcChipAccent___DDqbR`,
	"calcLabel": `InvoiceForm-module_calcLabel___H7T4b`,
	"calcValue": `InvoiceForm-module_calcValue___ECviE`,
	"rightCol": `InvoiceForm-module_rightCol___GnVxl`,
	"seatList": `InvoiceForm-module_seatList___mns6H`,
	"seatRow": `InvoiceForm-module_seatRow___SIC73`,
	"emptySeats": `InvoiceForm-module_emptySeats___GJKuZ`,
	"buttons": `InvoiceForm-module_buttons___LMI0P`,
	"marketplaceDropdown": `InvoiceForm-module_marketplaceDropdown___YnHCa`
};
export default ___CSS_LOADER_EXPORT___;
